// extracted by mini-css-extract-plugin
export default {"banner__div":"Banner_banner__div__XLrLx"};